/// <amd-module name="Search/WorkItem/Components/LeftPane/ItemRow" />
import * as React from "react";
import { WorkItemResult } from "Search/LegacyWebApi/Contracts/WorkItem";
import { MetadataSection } from "Search/WorkItem/Components/LeftPane/MetadataSection";
import { Snippet } from "Search/WorkItem/Components/LeftPane/Snippet";
import { TitleSection } from "Search/WorkItem/Components/LeftPane/TitleSection";
import { IHighlightFragment } from "Search/WorkItem/Flux/Stores/SnippetFragmentCache";
import { IVssPageContext } from "VSS/Platform/Context";

export interface IItemRowProps {
    item: WorkItemResult;
    index: number;
    idWidth: number;
    pageContext: IVssPageContext;
    onWorkItemInvoked(workItemId: number, index: number, url: string, openInNewTab: boolean): void;
    onRenderComplete(): void;
}

const WidthForEachDigit = 8;
const BufferWidthForWorkItemId = 3;

export class ItemRow extends React.PureComponent<IItemRowProps> {
    public render(): JSX.Element {
        const { item, idWidth, onWorkItemInvoked } = this.props;
        const aggregatedHits: { [key: string]: IHighlightFragment } = {};
        const fields: { [id: string]: string } = {};
        // Calculating width for the work item ID by giving each digit 8px size and a buffer of 3px
        const idWidthCalculated = idWidth * WidthForEachDigit + BufferWidthForWorkItemId;

        item.hits.forEach(hit => {
            const aggHit = aggregatedHits[hit.fieldReferenceName];
            if (aggHit) {
                aggHit.highlights = [...aggHit.highlights, ...hit.highlights];
            } else {
                aggregatedHits[hit.fieldReferenceName] =
                    {
                        refName: hit.fieldReferenceName,
                        name: hit.fieldName,
                        highlights: hit.highlights
                    };
            };
        });

        item.fields.forEach(field => fields[field.referenceName] = field.value);

        return (
            <div className="search-workitem-card flex-column fontSize">
                <TitleSection
                    project={item.project}
                    fields={fields}
                    aggregatedHits={aggregatedHits}
                    idWidth={idWidthCalculated}
                    pageContext={this.props.pageContext}
                    index={this.props.index}
                    onWorkItemInvoked={onWorkItemInvoked} />
                <MetadataSection
                    fields={fields}
                    project={item.project}
                    aggregatedHits={aggregatedHits} />
                <Snippet aggregatedHits={aggregatedHits} />
            </div>
        );
    }

    public componentDidMount(): void {
        if (this.props.onRenderComplete) {
            this.props.onRenderComplete();
        }
    }

    public componentDidUpdate(): void {
        if (this.props.onRenderComplete) {
            this.props.onRenderComplete();
        }
    }
}
